import {COOKIE_TYPES, VENDOR_TYPES} from './vendor-types.const'

export const VENDOR_LIST = [
  {
    name: 'Autopay',
    urls: [
      'https://autopay.pl',
      'https://autopay.eu',
      'https://autopay.de',
      'https://devcards.autopay.eu',
      'https://testcards.autopay.eu',
      'https://cards.autopay.eu',
    ],
    type: VENDOR_TYPES.necessary,
    id: 1,
    cookies: [
      {
        name: 'PHPSESSID',
        purpose: COOKIE_TYPES.functional,
        functionality: 'to store a user session',
        validity: 'session'
      },
      {
        name: 'TopupLang',
        purpose: COOKIE_TYPES.functional,
        functionality: 'to store a site language',
        validity: 'week'
      }
    ]
  },
  {
    name: 'Google Analytics',
    urls: ['https://www.google-analytics.com'],
    type: VENDOR_TYPES.survey,
    id: 2,
    cookies: [
      {
        name: '_gat_UA*',
        purpose: COOKIE_TYPES.functional,
        functionality: 'to provide technical monitoring',
        validity: 'session'
      },
      {
        name: '_gat_*',
        purpose: COOKIE_TYPES.functional,
        functionality: 'to read and filter requests from bots',
        validity: 'minute'
      },
      {
        name: '_gid',
        purpose: COOKIE_TYPES.statistics,
        functionality: 'to store and count pageviews',
        validity: 'day'
      },
      {
        name: '_ga',
        purpose: COOKIE_TYPES.statistics,
        functionality: 'to store and count pageviews',
        validity: '2years'
      },
      {
        name: '_ga_*',
        purpose: COOKIE_TYPES.statistics,
        functionality: 'to store and count pageviews',
        validity: 'year'
      }
    ]
  },
  {
    name: 'Google Tag Manager',
    urls: ['https://www.googletagmanager.com'],
    type: VENDOR_TYPES.survey,
    id: 3
  },
  {
    name: 'Google Adsense',
    urls: ['https://www.google.com/adsense'],
    type: VENDOR_TYPES.marketing,
    id: 4,
    cookies: [
      {
        name: '_gcl_au',
        purpose: COOKIE_TYPES.marketing,
        functionality: 'to store and track conversions',
        validity: 'persistent'
      },
      {
        name: 'google_pub_config',
        purpose: VENDOR_TYPES.marketing,
        functionality: 'to provide ad delivery or retargeting',
        validity: 'persistent'
      },
      {
        name: 'google_ama_config',
        purpose: VENDOR_TYPES.marketing,
        functionality: 'unknown',
        validity: 'persistent'
      },
      {
        name: 'google_ama_settings',
        purpose: VENDOR_TYPES.marketing,
        functionality: 'to store performed actions on the website',
        validity: 'persistent'
      },
      {
        name: 'google_adsense_settings',
        purpose: VENDOR_TYPES.marketing,
        functionality: 'to provide ad delivery or retargeting',
        validity: 'persistent'
      }
    ]
  },
  {
    name: 'Matomo',
    urls: ['https://piwik.blue.pl/', 'http://piwik.blue.pl/plugins'],
    type: VENDOR_TYPES.survey,
    id: 5,
    cookies: [
      {
        name: '_pk_ses*',
        purpose: COOKIE_TYPES.statistics,
        functionality: 'to store a unique session ID',
        validity: 'session'
      },
      {
        name: '_pk_id*',
        purpose: COOKIE_TYPES.statistics,
        functionality: 'to store a unique user ID',
        validity: '13months'
      },
      {
        name: '_pk_ref*',
        purpose: COOKIE_TYPES.statistics,
        functionality: 'to store referrer ID\'s',
        validity: '6months'
      }
    ]
  },
  {
    name: 'Matomo Tag Manager',
    urls: ['https://piwik.blue.pl/js'],
    type: VENDOR_TYPES.survey,
    id: 6
  },
  {
    name: 'Criteo',
    urls: [],
    type: VENDOR_TYPES.marketing,
    id: 7,
    cookies: [
      {
        name: 'cto_bundle',
        purpose: COOKIE_TYPES.marketing,
        functionality: 'to provide functions across pages',
        validity: '13months'
      }
    ]
  },
  {
    name: 'Hotjar',
    urls: ['https://www.hotjar.com'],
    type: VENDOR_TYPES.survey,
    id: 8,
    cookies: [
      {
        name: '_hjAbsoluteSessionInProgress',
        purpose: COOKIE_TYPES.statistics,
        functionality: 'to store unique visits',
        validity: 'session'
      }
    ]
  },
  {
    name: 'Bloomreach',
    urls: ['https://www.bloomreach.com'],
    type: VENDOR_TYPES.marketing,
    id: 9,
    cookies: [
      {
        name: '__exponea_time2__',
        purpose: COOKIE_TYPES.functional,
        functionality: 'to provide timezone',
        validity: 'hour'
      }
    ]
  },
  {
    name: 'Synerise',
    urls: ['https://synerise.com'],
    type: VENDOR_TYPES.marketing,
    id: 10,
    cookies: [
      {
        name: '_snrs',
        purpose: COOKIE_TYPES.statistics,
        functionality: 'unknown',
        validity: 'year'
      }
    ]
  },
  {
    name: 'Facebook',
    urls: ['https://facebook.com'],
    type: VENDOR_TYPES.marketing,
    id: 11,
    cookies: [
      {
        name: '_fbc',
        purpose: COOKIE_TYPES.marketing,
        functionality: 'to store last visit',
        validity: '2years'
      },
      {
        name: '_fbp',
        purpose: COOKIE_TYPES.marketing,
        functionality: 'to store and track visits across websites',
        validity: '3months'
      },
      {
        name: '*_fbm_',
        purpose: COOKIE_TYPES.marketing,
        functionality: 'to store account details',
        validity: 'year'
      }
    ]
  },
  {
    name: 'Facebook Pixel',
    urls: ['https://connect.facebook.net'],
    type: VENDOR_TYPES.survey,
    id: 12,
    cookies: [
      {
        name: '_fpb',
        purpose: COOKIE_TYPES.marketing,
        functionality: 'to store and track visits across websites',
        validity: '3months'
      }
    ]
  },
  {
    name: 'Google Ads',
    urls: ['https://googleads.g.doubleclick.net'],
    type: VENDOR_TYPES.advertisement,
    id: 13,
    cookies: [
      {
        name: '_gcl_aw',
        purpose: COOKIE_TYPES.marketing,
        functionality: 'to provide ad delivery or retargeting',
        validity: '90days'
      },
      {
        name: '_gac_UA-*',
        purpose: COOKIE_TYPES.marketing,
        functionality: 'to store and count pageviews',
        validity: '90days'
      },
      {
        name: 'goog_pem_mod',
        purpose: COOKIE_TYPES.marketing,
        functionality: 'to provide ad delivery or retargeting',
        validity: 'persistent'
      },
      {
        name: 'google_pem_mod',
        purpose: COOKIE_TYPES.marketing,
        functionality: 'to provide ad delivery or retargeting',
        validity: 'persistent'
      },
      {
        name: 'ads/ga-audiences',
        purpose: COOKIE_TYPES.marketing,
        functionality: 'to store information for remarketing purposes',
        validity: 'session'
      },
      {
        name: '_gac_*',
        purpose: COOKIE_TYPES.marketing,
        functionality: 'to store and track audience reach',
        validity: '90days'
      }
    ]
  },
  {
    name: 'Google Optimize',
    urls: ['https://www.googleoptimize.com'],
    type: VENDOR_TYPES.survey,
    id: 14,
    cookies: [
      {
        name: '_gaexp_rc',
        purpose: COOKIE_TYPES.marketing,
        functionality: 'unknown',
        validity: 'day'
      }
    ]
  },
  {
    name: 'Snap Pixel',
    urls: ['https://sc-static.net/scevent.min.js', 'https://tr.snapchat.com'],
    type: VENDOR_TYPES.survey,
    id: 15,
    cookies: [
      {
        name: '_schn',
        purpose: COOKIE_TYPES.marketing,
        functionality: 'to store and track visits across websites',
        validity: 'session'
      }
    ]
  },
  {
    name: 'TikTok Pixel',
    urls: ['https://analytics.tiktok.com/i18n/pixel'],
    type: VENDOR_TYPES.survey,
    id: 16,
    cookies: [
      {
        name: '_ttp',
        purpose: COOKIE_TYPES.marketing,
        functionality: 'To measure and improve the performance of your advertising campaigns and to personalize the user\'s experience on TikTok',
        validity: '13months'
      }
    ]
  },
  {
    name: 'Microsoft Clarity',
    urls: ['https://www.clarity.ms'],
    type: VENDOR_TYPES.survey,
    id: 17,
    cookies: [
      {
        name: '_cltk',
        purpose: COOKIE_TYPES.statistics,
        functionality: 'to Store and track interaction',
        validity: 'session'
      },
      {
        name: 'ANONCHK',
        purpose: COOKIE_TYPES.marketing,
        functionality: 'unknown',
        validity: 'session'
      },
      {
        name: '_clck',
        purpose: COOKIE_TYPES.marketing,
        functionality: 'to store a unique user ID',
        validity: 'year'
      },
      {
        name: '_clsk',
        purpose: COOKIE_TYPES.statistics,
        functionality: 'to store and combine pageviews by a user into a single session recording',
        validity: 'day'
      },
      {
        name: 'MUID',
        purpose: COOKIE_TYPES.marketing,
        functionality: 'to store and track visits across websites',
        validity: 'year'
      }
    ]
  },
  {
    name: 'YourCX',
    urls: ['https://static.opiniac.com', 'https://static.yourcx.io', '//static.yourcx.io'],
    type: VENDOR_TYPES.survey,
    id: 18,
    cookies: []
  }
]
